export const CardProps = {
    image: {
        default: 'https://picsum.photos/1280/720'
    },
    alt: {
        default: 'mix it web'
    },
    imageLink: {
        default: 'javascript:void(0)'
    },
    linkTarget: {
        default: '_self'
    }
}